/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */

import React from 'react';
import { usePermission } from '../hooks/usePermission';

interface PermissionGateProps {
  permission: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * Basit PermissionGate.
 * - permission varsa `usePermission().hasPermission` ile kontrol eder.
 * - Yoksa render etmez (fallback varsa onu basar).
 */
export function PermissionGate({ permission, children, fallback = null }: PermissionGateProps) {
  const { hasPermission } = usePermission();
  if (!permission) return <>{children}</>;
  return hasPermission(permission) ? <>{children}</> : <>{fallback}</>;
}

